import React from "react";

/**
 * GLOBAL FULL-SCREEN LOADER
 * Uses ONLY your CSS loader
 */
export const GlobalLoader = ({ show }) => {
  if (!show) return null;

  return (
    <div style={overlayStyle}>
      <span className="loader"></span>
    </div>
  );
};

const overlayStyle = {
  position: "fixed",
  inset: 0,
  background: "rgba(0, 0, 0, 0.45)", // dark overlay
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
};
